<template>
  <MyModal
    title="容量规划"
    width="454px"
    :style="{ top: '115px', right: '50px', left: 'unset' }"
    height="auto"
    @closeClick="handleCloseModalClick"
  >
    <div class="my-face-content">
      <div class="form-area">
        <div class="row">
          <div class="row-item">
            <div class="key"><span>面积</span> :</div>
            <div class="value">
              <el-tag>{{ windSelectionInfo.area || '-' }} k㎡</el-tag>
            </div>
          </div>
          <div class="row-item">
            <div class="key"><span>容量</span> :</div>
            <div class="value">
              <el-tag>{{ windSelectionInfo.cap || '-' }} MW</el-tag>
            </div>
          </div>
        </div>
        <!-- <div class="form-item">
          <div class="key">高级设置</div>
          <div class="value">
            <el-switch v-model="advanced" active-color="#6290F7"> </el-switch>
          </div>
        </div> -->
        <div v-if="advanced">
          <div class="form-item">
            <div class="key">最低风速</div>
            <div class="value">
              <StandInput
                v-model="windSelectionInfo.avgSpeedYear"
                :onlyNumber="true"
                unit="m/s"
              ></StandInput>
            </div>
          </div>
          <div class="form-item">
            <div class="key">最高海拔</div>
            <div class="value">
              <StandInput
                v-model="windSelectionInfo.altitudeTo"
                :onlyNumber="true"
                :precision="1"
                unit="m"
              ></StandInput>
            </div>
          </div>
          <div class="form-item">
            <div class="key">最大坡度</div>
            <div class="value">
              <StandInput
                v-model="windSelectionInfo.slopeTo"
                :onlyNumber="true"
                unit="%"
              ></StandInput>
            </div>
          </div>
          <!--          <div class="form-item">-->
          <!--            <div class="key">土地利用系数</div>-->
          <!--            <div class="value">-->
          <!--              <StandInput-->
          <!--                v-model="windSelectionInfo.landUseRatio"-->
          <!--                :onlyNumber="true"-->
          <!--              ></StandInput>-->
          <!--            </div>-->
          <!--            <el-tooltip-->
          <!--              effect="light"-->
          <!--              placement="right-start"-->
          <!--              class="desc-tooltip"-->
          <!--              popper-class="my-tooltip-right"-->
          <!--              style="margin-left: 5px"-->
          <!--            >-->
          <!--              <div slot="content" style="font-size: 14px">-->
          <!--                <span>土地利用系数说明:</span><br />-->
          <!--                <span># 湿地 0</span><br />-->
          <!--                <span># 水体 0</span><br />-->
          <!--                <span># 湿地 0</span><br />-->
          <!--                <span># 苔原 0</span><br />-->
          <!--                <span># 城市 0</span><br />-->
          <!--                <span># 冰雪 0</span><br />-->
          <!--                <span># 耕地 0.6</span><br />-->
          <!--                <span># 森林 0.6</span><br />-->
          <!--                <span># 草地 0.8</span><br />-->
          <!--                <span># 灌木 0.8</span><br />-->
          <!--                <span># 裸地 1</span>-->
          <!--              </div>-->
          <!--              <i class="el-icon-question"> </i>-->
          <!--            </el-tooltip>-->
          <!--          </div>-->
        </div>
      </div>

      <div class="lx-limit-area" v-if="advanced">
        <div class="my-title">
          限制区域
          <i
            :class="[
              'el-icon-circle-plus-outline',
              {
                'is-active': toolUIStatus.lxLimitAdd
              }
            ]"
            @click="
              () => {
                handleLimitClick();
              }
            "
          ></i>
        </div>
        <div class="area-content">
          <div
            class="depoly-content-item"
            v-for="(item, index) in exclusiveList"
            :key="index"
          >
            <el-tag> 限制区域{{ Number(index) + 1 }}</el-tag>
            <div class="btns">
              <i
                :class="[
                  'el-icon-view',
                  {
                    'is-active': item.isShow
                  }
                ]"
                @click="handleViewClick(item, index)"
              ></i>
              <i
                class="el-icon-delete"
                @click="handleDelLimitClick(item, index)"
              ></i>
            </div>
          </div>
        </div>
      </div>

      <div class="btn-wrapper" v-if="advanced">
        <!--        <div class="adjust-desc-new" title="根据输入的约束条件自动给出满足资源要求的空间范围" v-if="advanced">-->
        <!--        -->
        <!--        </div>-->

        <ct-button type="primary" :btnClick="handleConfirm">开始规划</ct-button>
        <!-- <el-tooltip
          effect="light"
          placement="top-start"
          class="ra-tooltip"
          popper-class="my-tooltip"
        >
          <div slot="content" class="ra-tooltip-con">
            <span>说明：根据输入的约束条件自动给出满足资源要求的空间范围</span>
          </div>
          <i class="el-icon-question"> </i>
        </el-tooltip> -->
      </div>
    </div>
  </MyModal>
</template>

<script>
import flattenDepth from 'lodash/flattenDepth';
import { FLOW_COLORS } from '@/utils/constants';
import domtoimage from 'dom-to-image';
import {
  parseMapDataToGeoInfo,
  toFixed,
  parseGeoInfoToMapData
} from '../utils';
import StandInput from './stand-input';
import MyModal from './modal';
import { mapGetters } from 'vuex';
import { getToken } from '../../../utils';
import { hasPermission } from '@/permission/index';
export default {
  components: {
    MyModal,
    StandInput
  },
  props: {
    itemConfig: {
      type: Object,
      default: () => ({})
    },
    fromProjectList: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      colors: FLOW_COLORS,
      a: '',
      islx: false,
      advanced: true,
      config: {
        itemName: '',
        elementCode: ''
      },
      heightList: [],
      loading: false,

      windSelectionInfo: {
        cap: null,
        area: null,
        wspdMin: null,
        avgSpeedYear: null,
        // fullHour: null,
        altitudeTo: null,
        slopeTo: null,
        landUseRatio: null
        // distanceFrom: 90,
        // distanceTo: 10000
      },
      btnList: [
        {
          name: '风速',
          elementCode: 'wspd',
          dyValues: [],
          values: [3, 4, 5, 6, 7, 8, 9, 10],
          unit: 'm/s'
        },
        {
          name: '气温',
          elementCode: 't',
          dyValues: [],
          values: [-10, -5, 0, 5, 10, 15, 20, 25, 30],
          unit: '℃'
        },
        {
          name: '气压',
          elementCode: 'p',
          dyValues: [],
          unit: 'hPa',
          values: []
        },
        {
          name: '风功率',
          elementCode: 'wpd',
          unit: 'W/㎡',
          dyValues: [],
          values: [0, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]
        }
      ],
      exclusiveList: [],
      datasetCode: '',
      datasetHeight: '',
      area: '',
      cap: '',
      elementCode: '',
      legendRange: '',
      itemId: '',
      activeValues: [],
      activeUnit: '',
      picName: '',
      isShowFace: true
    };
  },
  computed: {
    ...mapGetters(['isLogin']),
    ...mapGetters('WindFarm', [
      'toolUIStatus',
      'dataSet',
      'projectList',
      'turbineList'
    ]),
    classNames() {
      if (!this.isLogin) {
        return 'not-login';
      } else {
        return '';
      }
    }
  },
  watch: {
    config: {
      handler(val) {
        this.$emit('update:itemConfig', val);
      }
    },

    datasetCode: {
      handler(val) {
        this.config.datasetCode = val;
      },
      immediate: true
    },

    elementCode: {
      handler(val) {
        this.config.elementCode = val;
      },
      immediate: true
    },

    legendRange: {
      handler(val) {
        this.config.legendRange = val;
      },
      immediate: true
    },

    itemConfig: {
      handler(val, prev) {
        if (!val) return;

        this.isShowFace = true;

        if (prev) {
          this.islx = false;
        }

        this.config = val;

        const {
          datasetCode = '',
          elementCode = '',
          legendRange = '',
          area = '',
          cap = '',
          itemId = ''
        } = val;

        if (datasetCode) {
          const item = this.dataSet.find(
            item => item.datasetCode === datasetCode
          );
          console.log(item);
          this.datasetCode = datasetCode;
        } else {
          const firstItem = this.dataSet[0];
          this.datasetCode = firstItem?.datasetCode;
        }

        this.elementCode = elementCode;
        this.legendRange = legendRange;
        this.area = area;
        this.cap = cap;

        this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
          type: 'lx-limit-area',
          data: []
        });

        if (this.datasetCode) {
          this.queryUrl({
            datasetCode: this.datasetCode,
            itemId: itemId,
            elementCode: this.elementCode,
            legendRange: this.legendRange,
            area: this.area,
            cap: this.cap
          });
        }
      },
      immediate: true
    },
    islx: {
      handler(val) {
        if (val) {
          this.querySelectionArea();
        } else {
          this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
            type: 'lx-limit-area',
            data: []
          });

          this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
            type: 'lx-result-area',
            data: []
          });
        }
      }
    }
  },
  created() {
     if (this.projectList.length <= 0) {
      this.$router.push({
        name: 'project-list',
        query: {
          projectId: this.$route.query.projectId,
          projectName: this.$route.query.projectName,
        },
      });
    }
    this.$bus.$on('createLXLimitAdd', this.createLxLimitAdd);
    setTimeout(() => {
      if (this.hasPerms('layer-landWspd')) {
        this.$bus.$emit('checkLayer', ['fengziyuan']);
      }
      this.$bus.$emit('checkLayer', 'tiandi');
    });
  },
  beforeDestroy() {
    this.$bus.$off('createLXLimitAdd', this.createLxLimitAdd);

    this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
      type: 'lx-limit-area',
      data: []
    });

    this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
      type: 'lx-result-area',
      data: []
    });
  },
  mounted() {
   
    this.querySelectionArea();
  },
  methods: {
    hasPerms(perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms);
    },
    handleCloseModalClick() {
      this.$bus.$emit('farmClick', 0);
    },
    getActiveUnit() {
      if (!this.elementCode) {
        return '';
      }
      return this.btnList.find(i => i.elementCode === this.elementCode)?.unit;
    },
    getActiveValues() {
      if (!this.elementCode) {
        return [];
      }

      if (this.legendRange == 2) {
        return this.btnList.find(i => i.elementCode === this.elementCode)
          .dyValues;
      }
      if (this.legendRange == 1) {
        return this.btnList.find(i => i.elementCode === this.elementCode)
          .values;
      }
      return [];
    },
    updateElemenCodeValue(max, min) {
      if (this.legendRange == 2 || this.elementCode === 'p') {
        const unit = (max - min) / 10;
        const newArr = new Array(11).fill('');

        const item = this.btnList.find(i => i.elementCode === this.elementCode);

        item.dyValues = newArr.map((i, index) => {
          let fixUnit = 0;
          if (this.elementCode === 'wspd') {
            fixUnit = 1;
          }

          return toFixed(min + unit * index, fixUnit);
        });

        if (this.elementCode === 'p') {
          const item = this.btnList.find(
            i => i.elementCode === this.elementCode
          );
          item.values = newArr.map((i, index) => {
            let fixUnit = 0;
            if (this.elementCode === 'wspd') {
              fixUnit = 1;
            }
            return toFixed(min + unit * index, fixUnit);
          });
        }
      }
    },
    handleConfirm() {
      if (this.turbineList.length > 0) {
        this.$confirm(`修改会影响原方案内容，是否继续? `, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.handleLxDClick();
        });
      } else {
        this.handleLxDClick();
      }
    },
    handleLxDClick() {
      let arr = [];
      this.exclusiveList.forEach(i => {
        arr.push(i.data);
      });

      const newArr = arr.map(i => {
        return i.map(item => [item.lng, item.lat]);
      });

      const strs = newArr
        .map(item => {
          return JSON.stringify({
            type: 'Polygon',
            coordinates: [item]
          });
        })
        .join(';');

      this.$fetch({
        method: 'POST',
        url: '/windfarm/project/plane/windSelection',
        data: {
          ...this.windSelectionInfo,
          geometryInfos: strs,
          planId: this.$route.query.planId
          // dataSet: this.itemConfig.datasetCode,
          // dataHeight: this.itemConfig.datasetHeight,
          // area: this.itemConfig.area,
          // cap: this.itemConfig.cap
        },
        showError: true,
        showLoading: {
          mask: true,
          loadingContent: '根据输入的约束条件自动给出满足资源要求的空间范围'
        },
        showSuccess: true
      }).then(() => {
        this.querySelectionArea();
      });
    },
    handleLimitClick(value) {
      let status;

      if (value !== undefined) {
        status = !value;
      } else {
        status = this.toolUIStatus['lxLimitAdd'];
      }

      this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
      this.$store.commit('WindFarm/SET_TOOL_UI_STATUS', {
        key: 'lxLimitAdd',
        value: !status
      });

      this.$store.commit('WindFarm/SET_TOOL_BAR_STATUS', {
        key: 'drawPolygon',
        value: !status
      });
    },
    handleViewClick(item) {
      item.isShow = !item.isShow;
      const arr = this.exclusiveList.filter(i => !!i.isShow).map(i => i.data);

      this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
        type: 'lx-limit-area',
        data: arr
      });
    },

    handleDelLimitClick(item, index) {
      this.exclusiveList.splice(index, 1);
      const arr = this.exclusiveList.filter(i => !!i.isShow).map(i => i.data);

      this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
        type: 'lx-limit-area',
        data: arr
      });
    },
    createLxLimitAdd(data) {
      this.handleLimitClick(false);

      const str = parseMapDataToGeoInfo(data, 'Polygon');
      this.exclusiveList.push({
        data: data,
        geo: str,
        isShow: true
      });

      const arr = this.exclusiveList.filter(i => !!i.isShow).map(i => i.data);

      this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
        type: 'lx-limit-area',
        data: arr
      });
    },
    querySelectionArea() {
      this.$fetch('/windfarm/project/plane/getWindSelection', {
        showError: true,
        params: {
          planId: this.$route.query.planId
        }
      }).then(res => {
        const { exclusiveList = [], itemSelectionList = {} } = res.data;

        this.exclusiveList = exclusiveList.map(i => {
          const { geometryInfo = '' } = i;

          return {
            ...i,
            data: geometryInfo ? parseGeoInfoToMapData(geometryInfo)[0] : [],
            isShow: true
          };
        });

        this.windSelectionInfo = {
          avgSpeedYear: itemSelectionList.wspd,
          wspdMin: itemSelectionList.wspdMin,
          // fullHour: itemSelectionList.fullLoadHours,
          altitudeTo: itemSelectionList.maxAltitude,
          slopeTo: itemSelectionList.maxSlope,
          landUseRatio: itemSelectionList.landUseRatio,
          cap: itemSelectionList.cap,
          area: itemSelectionList.area,
          distanceFrom: 90,
          distanceTo: 10000
        };

        const { geometryInfo: lxGeoInfo } = itemSelectionList;

        const lxMapData = lxGeoInfo ? JSON.parse(lxGeoInfo)['coordinates'] : [];

        getMap(lxMapData, 'lx-result-area');

        this.$store.commit('WindFarm/SET_RAW_POLYGONS_ARR', {
          type: 'lx-result-area',
          data: lxMapData
        });

        const arr = this.exclusiveList.filter(i => !!i.isShow).map(i => i.data);

        this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
          type: 'lx-limit-area',
          data: arr
        });

        function getMap(array, type) {
          if (!array.length) return array;

          if (Array.isArray(array) && typeof array[0] === 'number') {
            array[0] = {
              type,
              lat: array[1],
              lng: array[0]
            };

            array.length = 1;
            return 'change';
            // Reflect.deleteProperty(array, '1');
          } else {
            for (let i = 0; i < array.length; i++) {
              let flag = getMap(array[i], type);

              if (flag === 'change') {
                array[i] = array[i][0];
              }
            }
          }
        }
      });
    },
    handleDel() {
      this.$emit('del', this.itemConfig.id);
    },
    queryUrl(params) {
      if (!params.elementCode) return;
      const {
        datasetCode = '',
        itemId = '',
        area = '',
        cap = '',
        elementCode = '',
        legendRange = ''
      } = params;

      this.loading = true;
      if (this.fromProjectList) {
        this.$postForm('/windfarm/project/plane/getElementsPicPath', {
          data: {
            datasetCode,
            itemId: '0',
            elementCode,
            area,
            cap,
            legendRange,
            geometryInfo: this.itemConfig.code
              ? null
              : this.itemConfig.geometryInfo || null,
            adcode: this.itemConfig.code || null
          },
          noKey: this.fromProjectList,
          showError: true
        }).then(res => {
          this.loading = false;
          const { data } = res;
          const { atlas, max, min } = data;
          const tupuUrl = process.env.VUE_APP_API_HOST + '/windfarm' + atlas;
          // todo更新URL
          const arr = atlas.split('?');
          this.picName = arr[1].split('=')[1];

          this.updateElemenCodeValue(max, min);

          this.activeValues = this.getActiveValues();
          this.activeUnit = this.getActiveUnit();

          this.$emit('updateImg', {
            id: itemId,
            url: tupuUrl + '&version=' + new Date().valueOf()
          });
        });
      } else {
        this.$fetch('/windfarm/project/plane/getElementsPicPath', {
          params: {
            datasetCode,
            itemId,
            area,
            cap,
            elementCode,
            legendRange
          },
          showError: true
        }).then(res => {
          this.loading = false;

          const { data } = res;
          const { atlas, max, min } = data;
          const tupuUrl = process.env.VUE_APP_API_HOST + '/windfarm' + atlas;

          const arr = atlas.split('?');
          this.picName = arr[1].split('=')[1];

          // todo更新URL

          this.updateElemenCodeValue(max, min);

          this.activeValues = this.getActiveValues();
          this.activeUnit = this.getActiveUnit();

          this.$emit('updateImg', {
            id: itemId,
            url: tupuUrl + '&version=' + new Date().valueOf()
          });
        });
      }
    },
    imgDownLoad() {
      if (!this.picName) {
        return this.$message.warning('图片还没准备好，请稍后再试');
      }

      fetch(
        `${
          process.env.VUE_APP_API_HOST
        }/windfarm/project/plane/getElementsPic?url=${
          this.picName
        }&apiKey=${getToken()}&version=${new Date().valueOf()}`
      )
        .then(res => {
          return res.blob();
        })
        .then(data => {
          const blob = new Blob([data]);

          var link = document.createElement('a');
          var fileURL = URL.createObjectURL(blob);

          link.target = '_blank';
          link.href = fileURL;
          link.download = this.picName;
          link.click();
        });

      // this.$fetch(`/windfarm/project/plane/getElementsPic`, {
      //   params: {
      //     url: this.picName,
      //     version: new Date().valueOf()
      //   },
      //   showLoading: true,
      //   noJudge: true
      // }).then(res => {
      //   const blob = new Blob([res.data]);

      //   var link = document.createElement('a');
      //   var fileURL = URL.createObjectURL(blob);

      //   link.target = '_blank';
      //   link.href = fileURL;
      //   link.download = this.picName;
      //   link.click();
      // });

      // window.open(
      //   `${process.env.VUE_APP_API_HOST}/windfarm/project/plane/getElementsPic?url=${this.picName}`,
      //   '__parent'
      // );
      // const link = document.createElement('a');
      // link.href = `${process.env.VUE_APP_API_HOST}/windfarm/project/plane/getElementsPic?url=${this.picName}`;
      // link.download = this.picName;
      // link.target = '_blank';
      // link.style.display = 'none';
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
    },
    closeTupu() {
      this.$emit('updateImg', {
        id: this.itemConfig.itemId,
        url: ''
      });

      this.elementCode = '';
      this.activeValues = this.getActiveValues();
    },
    tupuDownLoad() {
      const node = document.getElementById('my-node');
      domtoimage.toJpeg(node).then(async dataurl => {
        const file = new File([dataURItoBlob(dataurl)], '图例.jpg', {
          type: 'jpg'
        });
        const formData = new FormData();
        const geometryInfos = this.itemConfig.geometryInfo;

        let data = parseGeoInfoToMapData(geometryInfos)[0];

        if (this.itemConfig.itemType === 4) {
          const result = await this.$fetch(
            '/windfarm/project/getRegionBoundary',
            {
              showError: true,
              params: {
                // 拿默认的
                regionId: this.itemConfig.adcode
              }
            }
          ).then(res => {
            const { data = {} } = res || [];
            const { regionBoundary = { coordinates: '' } } = data;

            let result = JSON.parse(regionBoundary).coordinates || [];
            return result[0][0].map(i => ({ lat: i[1], lng: i[0] }));
          });

          data = result;
        }

        const { maxLat, maxLon, minLat, minLon } = this.getMax(data);

        formData.append('apiKey', getToken());
        formData.append('elementCode', this.elementCode);
        formData.append('file', file);
        formData.append('itemId', this.itemConfig.itemId);
        formData.append('legendRange', this.legendRange);
        formData.append('picName', this.picName);
        formData.append('maxLat', maxLat);
        formData.append('maxLon', maxLon);
        formData.append('minLat', minLat);
        formData.append('minLon', minLon);

        this.$fetch({
          method: 'post',
          url: '/windfarm/project/plane/getKmzFile',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          noJudge: true,
          showLoading: true
        }).then(() => {
          const download = `${this.itemConfig.itemId}_${this.elementCode}_${this.legendRange}.kmz`;

          window.open(
            `${process.env.VUE_APP_API_HOST}/windfarm/project/plane/downKmz?kmzName=${download}`,
            '_parent'
          );
        });
      });

      function dataURItoBlob(dataURI) {
        // convert base64 to raw binary data held in a string
        // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
        var byteString = atob(dataURI.split(',')[1]);

        // separate out the mime component
        var mimeString = dataURI
          .split(',')[0]
          .split(':')[1]
          .split(';')[0];

        // write the bytes of the string to an ArrayBuffer
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }

        //Old Code
        //write the ArrayBuffer to a blob, and you're done
        //var bb = new BlobBuilder();
        //bb.append(ab);
        //return bb.getBlob(mimeString);

        //New Code
        return new Blob([ab], { type: mimeString });
      }
    },

    getMax(data) {
      let maxLat = -1000;
      let maxLon = -1000;
      let minLat = 1000;
      let minLon = 1000;

      const newData = flattenDepth(data, 4);

      newData.forEach(item => {
        const { lat, lng } = item;

        if (maxLat < lat) {
          maxLat = lat;
        }

        if (minLat > lat) {
          minLat = lat;
        }

        if (maxLon < lng) {
          maxLon = lng;
        }

        if (minLon > lng) {
          minLon = lng;
        }
      });

      return {
        maxLat,
        minLat,
        maxLon,
        minLon
      };
    }
  }
};
</script>

<style lang="less" scoped>
.my-face-content {
  padding: 10px;

  .form-area {
    background-color: #f9f9f9;
    border-radius: 7px;
    padding: 20px 20px 10px 20px;

    .form-item {
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      &.sp {
        margin-top: 15px;
      }
    }

    .key {
      margin-right: 5px;
      width: 85px;
      line-height: 30px;
      font-weight: 400;
      font-size: 13px;
    }
    .value {
      width: 120px;
    }
  }
  .row {
    /*padding: 5px 0px;*/
    display: flex;
    align-items: center;
    .row-item {
      flex: 1;
      display: flex;
      align-items: center;
      width: 10px;
      &:nth-of-type(2n + 1) {
        flex: 1;
      }
      .key {
        span {
          width: 30px;
          display: inline-block;
        }
      }
      .value {
        margin-left: 0px;
        flex: 1;
        .el-tag {
          background: none;
          border: none;
          color: #000005;
        }
      }
      .plus-content {
        position: absolute;
        color: #fff;
        font-size: 12px;
        right: 30px;
        /*top: 80px;*/
        z-index: 2000;
        color: #000000;
      }
      &:nth-of-type(2n) {
        margin-left: 10px;
      }
    }
  }
}
.top-area {
  background-color: #f7f8ff;
  .item {
    height: 36px;
    display: flex;
    align-items: center;
    padding: 3px 0px;
    .label {
      color: #000;
      width: 48px;
      text-align: right;
      margin-right: 10px;
    }
    .desc {
      color: #555;
      .el-select {
        width: 207px;
      }
    }
  }
}
.btn-area {
  margin-top: 10px;
  display: flex;
  .btn-item {
    display: inline-block;
    padding: 5px;
    line-height: 20px;
    flex: 1;
    border: 2px solid rgba(83, 125, 252, 0.2);
    text-align: center;
    border-radius: 2px;
    cursor: pointer;
    margin-bottom: 13px;
    background-color: #f4f5f8;

    &:not(:last-child) {
      margin-right: 5px;
    }

    &.is-active {
      background-color: #537dfc;
      color: #fff;
    }
  }
}

.pic-area {
  background-color: #fff;
  border-radius: 6px;
  padding: 10px;
  .img-current {
    width: 100%;
  }
}
.link-area {
  text-align: right;
  //margin-top: 10px;
  // display: flex;
}

.data-area {
  padding-top: 20px;
  text-align: center;
  margin-bottom: 10px;
  .key-box {
    float: left;
    padding-left: 17px;
  }
}
.lx-limit-area {
  margin-top: 10px;

  .area-content {
    margin-top: 10px;
    padding: 0px 10px;
    max-height: 120px;
    overflow: auto;
  }
  .depoly-content-item {
    .el-tag {
      color: #537dfc;
      background: none;
      border: none;
      box-sizing: border-box;
      border-radius: 2px;
    }
    &:nth-child(n + 1) {
      margin-top: 5px;
    }
    display: flex;
    align-items: center;
    position: relative;
    & > span {
      display: flex;
      align-items: center;
    }

    .btns {
      display: flex;
      align-items: center;
      position: absolute;
      right: 0;
      i {
        display: flex;
        align-items: center;
        cursor: pointer;

        &.is-active {
          color: #3cc2e6;
        }
        &:hover {
          color: #478beb;
        }
        &:first-child {
          margin-right: 10px;
        }
      }
    }
  }

  .my-title {
    font-weight: normal;
    font-size: 16px;
    color: #000;
    padding: 0px 10px;
    position: relative;
    &::before {
      content: '';
      display: block;
      position: absolute;
      left: 0px;
      top: 1px;
      border-radius: 3px;
      width: 3px;
      height: 100%;
      background-color: #537dfc;
    }
    i {
      cursor: pointer;
      &:hover {
        color: #478beb;
      }
      &.is-active {
        color: #0159ac;
      }
    }
  }
}
.adjust-desc-new {
  position: absolute;
  width: 330px;
  margin-right: 120px;
  margin-top: 7px;
  font-weight: 800;
  color: #ff8b24;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.btn-wrapper {
  margin-top: 10px;
  text-align: center;
}
.desc-tooltip {
  &::before {
    content: url('../images/tootip-desc.png');
  }
}
</style>
